export default "__VITE_ASSET__DLwbPJOW__"